const posText = el => {
  const item = el;
  item.style.transform = `translateY(${window.scrollY}px)`;
};

const stickyItems = document.querySelectorAll('.c-text--sticky');

if (stickyItems) {
  stickyItems.forEach(item => {
    window.addEventListener('scroll', () => posText(item));
  });
}



// WEBPACK FOOTER //
// ./src/scripts/modules/sticky.js